<template>
	<div class="page">
		<banner :food_img="food_img" :state="state" @apply="apply" @reserve="reserve" :id="id" />
		<applyStateComponent class="apply-state" :title="title" :try_subtitle="try_subtitle" :nextText="nextText" :nextStyle="nextStyle" :nextTid="nextTid" :state="state" v-if="title" />
		<div style="" class="container">
			<div style="padding-bottom: 0" class="containerMiddle2">
				<div class="detail_main">
					<div class="detail_main_content">
						<div class="coupon" v-if="hasCoupon">
							<p class="coupon-infor">申请试用还可获得{{couponTitle}}</p>
							<img class="coupon-img" :src="couponImg" alt="">
						</div>
						<ul id="tab" class="tab">
							<li @click="tabId = item.id" :class="{ active: item.id == tabId }" class="fontSize4"
								v-for="item in tabs" :key="item.id">
								{{ item.name }}
								<div class="tabLine"></div>
							</li>
						</ul>
						<ul id="tab" class="tab fixed" v-show="fixedTab">
							<li @click="tabId = item.id" :class="{ active: item.id == tabId }" class="fontSize4"
								v-for="item in tabs" :key="item.id">
								{{ item.name }}
								<div class="tabLine"></div>
							</li>
						</ul>
						<div style="width: 100%; margin: 0 auto">
							<div class="detail_info" style="padding: 0.018rem;" v-html="detail_info_mobile"
								v-show="tabId == 1"></div>
							<div class="tabItem" v-show="tabId == 2">
								<!--试用报告BEGIN-->
								<ul class="report-list" v-if="selected.length > 0">
									<li class="report-item" v-for="item in selected" :key="'sel'+item.id">
										<div class="report-box u-flex u-row-between  u-col-top">
											<div class="video-content" v-if="item.video_id != '0'">
												<a :href="item.video_url">
													<img :src="item.video_img" class="video-cover" alt="">
												</a>
											</div>
											<div class="report-content">
												<div class="report-auth u-flex u-row-between">
													<div class="avatar u-flex">
														<img :src="item.avatar || require('@/assets/avatar-img.png')" alt="">
														<div class="auth-name elli1">{{item.nickname}}</div>
													</div>

													<div class="like-btn" @click="dianzan(item.id)">
														<span class="like-icon"></span>
														<span class="like-num">{{item.replycount}}</span>
													</div>
												</div>
												<div class="report-text elli3">
													{{item.reason}}
												</div>
												<div class="report-btn" v-if="item.report_url">
													<a :href="item.report_url" target="_blank">查看试用报告></a>
												</div>
												<div class="report-btn-red" v-else-if="cate_id === '6' && state === 'end'">
                          申请成功
												</div>
                        <div v-else class="report-btn report-btn-disabled">试用报告敬请期待～</div>
											</div>
										</div>
									</li>
								</ul>
								<!--试用报告END-->

								<!--申请列表BEGIN-->
								<ul class="report-list apply-list" v-if="applyList.length > 0">
									<li class="report-item" v-for="item in applyList" :key="item.id">
										<div class="report-box u-flex u-row-between  u-col-top">
											<div class="report-content">
												<div class="report-auth u-flex u-row-between">
													<div class="avatar u-flex">
														<img :src="item.avatar || require('@/assets/avatar-img.png')" alt="">
														<div class="auth-name elli1">{{item.nickname}}</div>
													</div>

													<div class="like-btn" @click="dianzan(item.id)">
														<span class="like-icon"></span>
														<span class="like-num">{{item.replycount}}</span>
													</div>
												</div>
												<div class="report-text">
													{{item.reason}}
												</div>
												<div class="time">
													{{ item.created_at }}
												</div>
											</div>
										</div>
									</li>
								</ul>
								<!--申请列表END-->

								<div class="loadMore" :class="{'height300': applyList.length === 0}">
										<span v-show="!listFinished" style="display: flex; align-items: center">
											<img width="14px" style="margin-right: 4px" src="../assets/loading.gif"
												 alt="" />
											加载中...
										</span>
									<div class="no-more-box" v-show="listFinished">
										<span>没有更多了~</span>
										<div class="no-more" v-if="applyList.length === 0">
											<img src="~@/assets/detail/icon-no-more.png" alt="">
										</div>
									</div>
								</div>
							</div>

							<div class="tabItem" v-show="tabId == 3">
								<div class="rule detail_info" v-html="rule"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container-button" v-if="state == 'ing'">
			<div class="base-btn" @click.prevent="apply()">申请试用 ></div>
		</div>
		<div style="width: 100%;height: 20px;"></div>

		<!-- <div class="bottomBg">
      <img src="@/assets/bottomBg.png" />
      <div class="bottomContent">
        <countdown class="left" />
        <div class="right">
          <span class="fontSize2" v-if="state == 'start'">即将开始 </span>
          <a @click="apply" class="state ing bold" v-if="state == 'ing'"
            ><h3>申请试用</h3></a
          >
          <a class="bold fontSize2" v-if="state == 'end'">
            <span v-if="report_url">试用报告已公布</span>
            <span v-else-if="selected.length">试用名单已公布</span>
            <span v-else>已结束</span>
          </a>
        </div>
      </div>
    </div>  -->

    <!--页面底部固定提示-->
    <div class="bottom-tips" v-if="state === 'ing' || state === 'start'">
      <div class="main">
        <div class="text" v-if="state === 'ing'">
          免费获取产品/服务试用资格，<br>点击右侧按钮立即申请 >
        </div>
        <div class="text" v-if="state === 'start'">
          试用开始立即获取消息通知，<br>点击右侧按钮立即预约 >
        </div>
        <!--如果正在进行中显示申请按钮-->
        <div class="button" v-if="state === 'ing'" @click.prevent="apply()">申请试用 ></div>
        <!--如果未开始显示预约按钮-->
        <div class="button button-reserve" v-if="state === 'start'" @click.prevent="reserve()">预约提醒 ></div>
      </div>
    </div>

		<div class="qr-dialog" v-if="showWXQRCode">
			<div class="qr-content">
				<img src="../assets/indexQRCode.png" alt="" />
			</div>
			<img @click="showWXQRCode = false" class="close-icon" src="../assets/close.png" alt="" />
		</div>
	</div>
</template>

<script>
	import "../../node_modules/swiper/dist/css/swiper.css";
    import Swiper from "swiper";
	import banner from "@/components/banner.vue";
	import applyStateComponent from "@/components/apply-state.vue";
	import { mapState } from "vuex";

	export default {
		name: "page3",
		data() {
			return {
				applyList: [],
				tabs: [
					{
						name: "商品详情",
						id: 1,
					},
					{
						name: "申请名单",
						id: 2,
					},
					{
						name: "试用规则 ",
						id: 3,
					},
				],
				id: 0,
				tabId: 1,
        cate_id: 0,
				rule: "",
				title: "",
				try_subtitle: "",
				detail_info_mobile: "",
				food_img: '',
				showId: "",
				showLoadMore: false,
				fixedTab: false,
				loading: false,
				p: 1,
				listFinished: false,
				showWXQRCode: false,
				selected: [],
				report_url: "",
				stage: "",
				swiperReport: null,
				hasCoupon: false,
				couponTitle: '',
				couponImg: '',
				nextTid:0,
				nextStyle: '',
				nextText: '',
			};
		},
		watch: {
			'$route': 'init'
		},
		methods: {
			dianzan(id) {
				this.$router.push("/show/" + id);
				//this.$store.commit('showQrCode','http://www.dellemc-solution.com/campaigns/try/mobile-c/#/show/'+id);
			},

			gioPageSet() {
				const option = {
          module:'eshop促销活动',
          category1: '0元试用',
          category2: '详情页',
          title: `【${this.title}】详情页`
				}
				this.gioPageAction(option)
			},

			isWxClient() {
				var ua = navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					return true;
				}
				return false;
			},
			apply() {
				//测试用
				// this.$store.commit("setState", {
				// 	applyformShow: true,
				// });
				// return;

				if (this.$store.state.authed === false) {
					if (this.isWxClient()) {
                        if (this.is_member) return window.location.href = 'https://www.dellemc-solution.com/campaign/jump-xcx?path=pages%2Fintegral%2Findex';
						// let callbackUrl = encodeURIComponent(window.location.href), oauthGateway = '';
						let oauthGateway = '';
						if(process.env.VUE_APP_FLAG === "pro"){
							oauthGateway = `/campaigns-b/try/index.php?_c=callback&_a=oauth&page=detail&id=${this.$route.params.id}`;
						}else{
							oauthGateway = `/campaigns-b/try/index.php?_c=callback&_a=oauth&page=detail&id=${this.$route.params.id}`;
						}
						window.location.href = oauthGateway;
						// window.location.href = `/campaigns-b/try/index.php?_c=callback&_a=oauth&page=detail&id=${this.$route.params.id}`;
					} else {
						this.showWXQRCode = true;
					}
					return;
				}
				//申请过了
				if (this.showId) {
					if(this.$store.state.miniapp){
						wx.miniProgram.redirectTo({url: `/pages/try/show?aid=${this.showId}`});
						return;
					}else{
						this.$router.push("/show/" + this.showId);
						return;
					}
				}
				let smarketCookie = this.cookies.get("smarketMember_498");
				if (smarketCookie) {
					this.$store.commit("setState", {
						applyformShow: true,
					});
          const option = {
              module:'eshop促销活动',
              category1: '0元试用',
              category2: '试用申请',
              title: `【${this.title}】申请试用`
          }
          this.gioPageAction(option)
				} else {
					window.location.href =
						"https://www.dellemc-solution.com/account/login?defaultSms=1&backUrl=" +
						encodeURIComponent(window.location.href) + '&linksourcemodule=eshop促销活动&category1=0元试用&category2=试用申请';
				}

				if (this.report_url && this.report_url.indexOf("http") > -1) {
					window.open(this.report_url);
				}
				gioTrackAction("campaign0yuan_applyclick");
			},

      // 预约
      async reserve(){
        let res = await this.axios.post('https://www.dellemc-solution.com/api/xcx/urlSchemeCreate', {
          path: 'pages/trial/info',
          query: 'id=' + this.id
        })
        if(res.status !== 200) {
          return;
        }
        this.xcxUrl = res.data.data.src
        // 确认是否需要跳转
        if(window.confirm('即将跳转到戴尔企采小程序进行预约')){
          location.href = this.xcxUrl;
        }
      },

			getListData() {
				return new Promise((resolve, reject) => {
					if (this.listFinished) {
						reject();
						return;
					}
					this.axios
						.get(
							"/campaigns-b/try/index.php?_c=detail&_a=applylist&tid=" +
							this.$route.params.id +
							"&p=" +
							this.p +
							"&size=" +
							config.pageSize
						)
						.then((response) => {
							if (this.p == 1) {
								response.data.data.forEach((item, index) => {
									this.applyList.push(item)
								})
							} else if (response.data.data && response.data.data.length > 0) {
								this.applyList = this.applyList.concat(response.data.data);
							}
							if (this.p >= response.data.msg) {
								this.listFinished = true;
								reject();
								return;
							}
							this.p++;
							resolve();
						})
						.catch(function (error) {
							// 请求失败处理
							console.log(error);
						});
				});
			},
			loadMore() {
				if (this.loading === true) return;
				this.loading = true;

				this.showLoadMore = true;
				this.getListData()
					.then(() => {
						this.showLoadMore = false;
						setTimeout(() => {
							//$(document).scrollTop(100);
							this.loading = false;
						}, 100);
					})
					.catch(() => {
						this.showLoadMore = false;
					});
			},
			init() {
				this.$store.commit("setState", {
					hasCoupon: false,
					couponTitle: '',
					couponImg: '',
					couponUrl: '',
				});
				this.getCoupon();
				// alert(`/campaigns-b/try/index.php?_c=callback&_a=oauth&page=detail&id=${this.$route.params.id}`)
				//document.title = '详情页';
				this.axios
					.get(
						"/campaigns-b/try/index.php?_c=detail&_a=get&tid=" +
						this.$route.params.id
					)
					.then((response) => {
						var d = response.data.data;
						this.food_img = d.banner_pic;
						this.id = d.id;
						this.cate_id = d.cate_id;

						this.$store.commit("init", {
							/*
								pageBgStyle : {
								  'background-image' : 'url('+require('/assets/'+response.data.detail_bgm_pc)+')'
								},
								*/
							startTime: new Date(d.date_begin.replace(/-/g, "/")).getTime(),
							endTime: new Date(d.date_end.replace(/-/g, "/")).getTime(),
							sqrCount: d.applytotal,
							stage: d.try_stage,
							price: d.try_price,
							tid: this.$route.params.id,
							site_yhxy: d.site_yhxy,
							detailId: d.id,
							selected: d.selected ? d.selected : [],
							report_url: d.report_url ? d.report_url : false,
							totalNum: d.total,
							applyNum: d.applytotal,
						});

						//this.applyList = response.data.applyList;
						this.rule = d.detail_rule_pc;
						this.title = d.try_title;
						this.try_subtitle = d.try_subtitle;
						this.stage = d.try_stage;
						this.is_member = d.is_member === '1';
						this.selected = d.selected ? d.selected : [];
						this.report_url = d.report_url ? d.report_url : false;

						this.detail_info_mobile = d.detail_info_m;

						if(d.selected.length > 0){
							this.tabs[1].name = '试用报告';
						}
            // if(this.state === 'end' && this.cate_id === '6') {
            //   this.tabs[1].name = '申请成功';
            // }
						// if(d.selected.length > 1){
						// 	this.$nextTick(()=>{
						// 		this.initSwiperReport();
						// 	});
						// }

						if(d.next) {
							this.nextTid = d.next.id;
							this.nextText = d.next.try_stage;
							this.nextStyle = '';
						}else{
							this.nextTid = '';
							this.nextText = '';
							this.nextStyle = 'background: url(./images/detail-product-title-bg.png) top center/cover no-repeat;background-size: 100% 100%;';
						}

						config.routerCallback(Object.assign({}, d, { pageName: "detail", debug: process.env.VUE_APP_FLAG !== "pro" }));
						this.gioPageSet();
					})
					.catch(function (error) {
						// 请求失败处理
						console.log(error);
					});

				this.getListData()
					.then(() => { })
					.catch(function (error) {
						// 请求失败处理
						console.log(error);
					});
				this.axios
					.get(
						"/campaigns-b/try/index.php?_c=detail&_a=hasapply&tid=" +
						this.$route.params.id
					)
					.then((response) => {
						var d = response.data.data;
						if (response.data.code == 500) {
							console.log("已经申请过了");
							this.showId = d.id;
						}

						if (response.data.code == 200) {
						}
					})
					.catch(function (error) {
						// 请求失败处理
						console.log(error);
					});
			},
			initSwiperReport(){
				if(this.swiperReport) return;
				this.swiperReport = new Swiper('.swiper-report', {
					loop: true,
					speed: 600,
					slidesPerView: 'auto',
					pagination: {
						el: '.swiper-pagination',
					},
				});
			},
			getCoupon(){
				this.axios.get('/campaigns-b/try/index.php?_c=detail&_a=coupon&tid='+this.$route.params.id).then((response) => {
					if(response.data.code == 200 && response.data.data.coupon_title){
						this.hasCoupon = true;
						this.couponTitle = response.data.data.coupon_title;
						this.couponImg = response.data.data.coupon_image;
						this.$store.commit("setState", {
							hasCoupon: true,
							couponTitle: response.data.data.coupon_title,
							couponImg: response.data.data.coupon_image,
							couponUrl: response.data.data.coupon_url,
						});
					}
				}).catch(function (error) { // 请求失败处理
				});
			},
		},
		computed: {
			...mapState({
				state: "applyState",
				// stage: "stage",
			}),
		},
		mounted() {
			//给window添加一个滚动滚动监听事件
			var $tab = $("#tab");
			var $window = $(window);
			var $document = $(document);
			window.onscroll = () => {
				var scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				//var offsetTop = document.querySelector('#tab').offsetTop;
				//var containerTop = document.querySelector('.container').offsetTop;

				//console.log([scrollTop,scrollTop , (offsetTop+containerTop)])

				if (scrollTop >= $tab.offset().top) {
					this.fixedTab = true;
				} else {
					this.fixedTab = false;
				}

				if ($window.scrollTop() + $window.height() == $document.height()) {
					console.log("到底了");
					this.loadMore();
				}
			};
		},
		destroyed() {
			//离开该页面需要移除这个监听的事件
			if(this.swiperReport){
				this.swiperReport.destroy();
			}
			window.onscroll = function () { };
			this.$store.commit('setState', {
				init: false
			});
		},
		created() {
			this.init();
		},
		components: {
			banner,
			applyStateComponent
		},
	};
</script>

<style scoped lang="scss">
	.detail_main {
		box-sizing: border-box;
		padding: 1.2vw 1vw 2vw;
		width: 100%;
		background: #d2e8ff;
		border-radius: 6px;
	}

	.container{
		margin: 0 auto;
	}

	.detail_main_content {
		width: 100%;
		overflow: hidden;
		border: 1px dashed #5487e7;
		border-radius: 6px;
		padding-top: 2.1vw;
    background-color: #ffffff;
	}

	.detail_content_cutdown {
		padding: 0 2.5vw;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 2.1vw;
	}
	.coupon{
		margin-left: 2.5vw;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 2.1vw;
	}
	.coupon-infor{
		font-size: 3.2vw;
		font-weight: bold;
		color: #000000;
		margin-right: 3.73vw;
		max-width: 67vw;
	}
	.coupon-img{
		width: 12vw;
		height: 12vw;
	}
	.cutdown_left {
		width: 60%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.cutdown_right {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 21.5vw;
		height: 5vw;
		background: url('~@/assets/detail/userbtn.png') top center/cover no-repeat;
		background-size: 100% 100%;
		font-size: 0.36rem * 0.75;
		color: #000000;
		line-height: 5vw;
		font-weight: bold;
	}

	.cutdown_right>img {
		margin-left: 1.2vw;
		width: 2.1vw;
	}

	.logo {}

	.page {
		width: 100%;
		/* background: #1277da; */
		background: url('~@/assets/detail/detail-bg.jpg') repeat top center/contain;
	}

	.list {
		color: #fff;
	}

	.list .item {
		display: flex;
		background-color: #fff;
		border-radius: 0.052631rem * 0.75;
		padding: 0.115789rem * 0.75;
		padding-left: 0.178947rem * 0.75;
		padding-right: 0.178947rem * 0.75;
		margin-top: 0.078947rem * 0.75;
		margin-bottom: 0.078947rem * 0.75;
	}

	.list .item .img {
		width: 0.721052rem * 0.75;
		height: 0.721052rem * 0.75;
		margin-right: 0.157894rem * 0.75;
	}

	.item .column {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		width: 100%;
	}

	.item .stage {
		background-color: #73b2b6;
		border: 0.005263rem solid #379197;
		border-radius: 0.052631rem * 0.75;
		padding-left: 0.08421rem * 0.75;
		padding-right: 0.08421rem * 0.75;
		color: #fff;
	}

	.item .title {
		color: #000;
	}

	.item .gray {
		color: #7f7f7f;
	}

	.item .red {
		color: #a93a3a;
	}

	.content2 {
		background-image: url("./../assets/detail-content-bg.png");
		background-size: 100% auto;
		background-repeat: no-repeat;
		background-color: #f2dede;
		width: 100%;
		/*height: 6.8125rem * 0.75;*/
		box-sizing: border-box;
		padding-left: 0.803571rem * 0.75;
		padding-right: 0.803571rem * 0.75;
		padding-top: 1.071428rem * 0.75;
		padding-bottom: 0.5rem * 0.75;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.progress-view {
		position: relative;
		margin-top: 0.5rem * 0.75;
	}

	.progress-view::before {
		position: absolute;
		left: -0.803571rem * 0.75;
		right: -0.803571rem * 0.75;
		top: 0;
		content: "";
		height: 2px;
		background-color: #f7ecec;
	}

	.tab {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 89.4vw;
		height: 8vw;
		/* background: #3792EF; */
		box-shadow: 0px 1px 5px 0px rgba(12, 115, 216, 0.53);
		background: url('~@/assets/detail/tab-bg.png') top center/cover no-repeat;
		background-size: 100% 100%;
	}

	.tab.fixed {
		position: fixed;
		top: 0;
		z-index: 101;
		left: 0;
		width: 100%;
		height: 10vw;
	}

	.tab>li {
		position: relative;
		width: 15.4vw;
		text-align: center;
		font-size: 0.36rem * 0.75;
		color: #B3DDFC;
		line-height: 8vw;
	}

	.tab>li.active {
		/* font-size: 2.8vw; */
		color: #FFFFFF;
		font-weight: 600;
	}

	.active .tabLine {
		width: 100%;
		position: absolute;
		left: 0;
		bottom: 0;
		background-color: #d6eaff;
		height: 1.3vw;
		border-radius: 0.6vw;
	}

	.tab.fixed li {
		line-height: 10vw;
	}

	.tabItem {
		padding: 4vw 2.3vw;
	}

	.applyItem {
		width: 100%;
		height: auto;
		background: #FFFFFF;
		box-shadow: 0px 1px 0.5vw 0px rgba(12, 115, 216, 0.53);
		border-radius: 1.7vw;
		display: flex;
		padding: 1.3vw 1.5vw 2.5vw;
		margin-bottom: 1.2vw;
		position: relative;
	}

	.applyItem .itemRight {
		position: absolute;
		right: 1.5vw;
		top: 1.5vw;
	}

	.applyItem .portrait {
		width: 5vw;
		height: 5vw;
		border-radius: 50%;
	}

	.itemMiddle {
		width: 72.4vw;
		padding: 0.5vw 0 0 1.5vw;
		font-size: 2.8vw;
		color: #595959;
		line-height: 3.2vw;
	}

	.itemMiddle .title {
		font-size: 3.5vw;
		font-weight: bold;
		color: #000000;
		line-height: 3.2vw;
		margin-bottom: 1.9vw;
		width: 80%;
		height: 3.2vw;
	}

	.itemMiddle .apply-content {
		font-size: 3.2vw;
		line-height: 4vw;
		margin-bottom: 1.9vw;
	}

	.applyNum {
		display: flex;
		align-items: flex-end;
		font-size: 1.6vw;
		color: #FE5638;
		line-height: 2.4vw;
	}

	.applyNum img {
		width: 3.2vw;
		margin-right: 0.6vw;
	}

	.rule {
		padding: 5vw 3.5vw;
		font-size: 3.4vw;
		color: #595959;
		line-height: 5.1vw;
		background: #FFFFFF;
		box-shadow: 0px 1px 5px 0px rgba(12, 115, 216, 0.53);
		border-radius: 1.7vw;
	}

	.rule img {
		max-width: 100%;
	}

	.report_bt {
		margin-top: 0.1rem * 0.75;
		text-align: center;
		/* position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%); */
	}

	.report_bt a {
		display: block;
	}

	.report_bt a img {
		width: 30vw;
		height: 7.5vw;
	}

	.CountdownWrap {
		position: absolute;
		bottom: 0px;
		left: 0px;
	}

	.bottomBg {
		position: fixed;
		bottom: -0.031578rem * 0.75;
		left: 0px;
		width: 100%;
		padding: 0.015789rem * 0.75;
		box-sizing: border-box;
		display: flex;
		align-items: flex-end;
	}

	.bottomBg img {
		width: 100%;
	}

	.bottomBg .Countdown {}

	.bottomContent {
		display: flex;
		justify-content: space-between;
		position: absolute;
		bottom: 0.446428rem * 0.75;
		left: 10%;
		width: 80%;
		align-items: baseline;
	}

	.bottomContent .right {
		display: flex;
		justify-content: space-around;
		align-items: center;
		color: #fff;
	}

	.state {
		width: 2.678571rem * 0.75;
		height: 0.7rem * 0.75;
		text-align: center;
		line-height: 0.7rem * 0.75;
		color: #a32929;
		background-size: 100% auto;
		background-repeat: no-repeat;
	}

	.state h3 {
		margin-right: 0.2rem * 0.75;
	}

	.state.ing {
		background-image: url("./../assets/apply-state-ing.png");
	}

	.state.end {
		background-image: url("./../assets/apply-state-end.png");
	}

	.Countdown {
		background-image: none;
	}

	.loadMore {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 2.3vw;
		color: #0C73D8;
		line-height: 4.4vw;
		letter-spacing: 0.5vw;
		height: 1rem;
	}

	.qr-dialog {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: rgba(0, 0, 0, 0.6);
		z-index: 9999999;
	}

	.qr-dialog .qr-content {
		width: 5rem * 0.75;
		height: 6rem * 0.75;
		display: flex;
		justify-content: center;
		background-image: url('~@/assets/apply/qrbg.png');
		background-size: 100%;
		background-repeat: no-repeat;
		background-position: top;
	}

	.qr-dialog .qr-content img {
		margin-top: 0.6rem * 0.75;
		width: 3.6rem * 0.75;
		height: 3.6rem * 0.75;
	}

	.qr-dialog .close-icon {
		margin-top: 10px;
	}


	.container-button .button{
		width: 35.5vw;
		height: 7.1vw;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 4vw;
		font-weight: 600;
		cursor: pointer;
		color: #000000;
		line-height: 6.6vw;
		border-radius: 1.8vw;
		background: url('~@/assets/detail/userbtn.png') top center/cover no-repeat;
		background-size: 100% 100%;
	}
	.container-button .button img{
		width: 4.3vw;
		margin-left: 2.4vw;
	}
	.luck-itemMiddle {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		padding-left: 0.25rem * 0.75;
		font-size: 0.28571rem * 0.75;
		height: 33.4vw;
		width: 58vw;
	}
	.luck-container .swiper-container ::v-deep .swiper-pagination-bullet {
        background: #ccc;
        opacity: 1;
    }

    .luck-container .swiper-container ::v-deep .swiper-pagination-bullet-active {
        background: #0076ce;
    }
	.text-6 {
		display: -webkit-box;
		-webkit-line-clamp: 6;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.height300 {
		height: 3rem;
	}

	.no-more-box{
		text-align: center;
		font-size: .26rem;

		.no-more img{
			margin-top: .2rem;
			width: 1.99rem;
			height: 1.9rem;
		}
	}

	/*试用报告列表*/
	.report-list{
		.report-item{
			display: block;
			background-color: #fff;
			margin-bottom: .1rem;
			border-radius: .1rem;
			overflow: hidden;
			.report-box{
				.video-content{
					position: relative;
					flex-shrink: 0;
					a{
						display: block;
						width: 2.9rem;
						height: 2.34rem;
					}
					img{
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
					&::after{
						content: '';
						position: absolute;
						z-index: 1;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						display: block;
						width: .6rem;
						height: .6rem;
						background-image: url("~@/assets/detail/play.png");
						background-size: 100%;
					}
				}

				.report-content{
					margin-left: .15rem;
					padding-top: .25rem;
					padding-right: .15rem;
					height: 100%;
					flex: 1;
					.report-auth{
						margin-bottom: .15rem;
						line-height: .35rem;
						.avatar{
							/*width: 3rem;*/
							img{
								width: .37rem;
								height: .37rem;
								object-fit: cover;
								border-radius: 50%;
							}
							.auth-name{
								width: 1.8rem;
								margin-left: .1rem;
								font-size: .2rem;
								color: #000;
								font-weight: bold;
							}
						}
						.like-btn{
							.like-icon{
								position: relative;
								top: .02rem;
								width: .25rem;
								height: .25rem;
								display: inline-block;
								background-image: url("~@/assets/detail/like.png");
								background-size: 100%;
							}
							.like-num{
								padding-left: .05rem;
								font-size: .24rem;
								color: #fe5638;
							}
						}
					}
					.report-text{
						font-size: .19rem;
						line-height: .27rem;
						color: #000;
					}

					.report-btn{
						a{
							display: block;
							margin: .15rem auto .15rem;
							width: 1.68rem;
							height: .36rem;
							line-height: .36rem;
							text-align: center;
							font-size: .19rem;
							color: #fff;
							background-image: linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);

							&:active {
								opacity: .9;
							}

							&.disabled {
								background-image: linear-gradient(-90deg, rgb(133, 133, 133) 1%, rgb(106, 106, 106) 100%);
							}
						}
					}

          .report-btn-red {
            display: block;
            margin: .15rem auto .15rem;
            width: 1.68rem;
            height: .36rem;
            line-height: .36rem;
            text-align: center;
            font-size: .19rem;
            color: #fff;
            background-image: linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);
          }

					.report-btn-disabled{
						display: block;
						margin: .15rem auto .15rem;
						width: 2rem;
						height: .36rem;
						line-height: .36rem;
						text-align: center;
						font-size: .19rem;
						color: #fff;
						background: #ccc;
					}
				}
			}
		}

	}
	.apply-list{
		.time{
			font-size: .15rem;
			color: #000;
			margin-top: .1rem;
			margin-bottom: .25rem;
		}
	}

  .bottom-tips{
    background-color: rgba(0,0,0,0.5);
    height: 1.2rem;
    position: fixed;
    bottom: 1.39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    z-index: 10;
    .main{
      display: flex;
      height: 100%;
      justify-content: space-between;
      align-items: center;
      padding: 0 .2rem;
      .text{
        width: 60%;
        font-size: .26rem;
        color: #fff;
        line-height: .4rem;
        margin-right: .2rem;
      }
      .button{
        width: 2.6rem;
        height: .6rem;
        font-size: .28rem;
        color: #fff;
        line-height: .6rem;
        text-align: center;
        background-image: linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);
        cursor: pointer;
      }
      .button-reserve{
        // 背景色是渐变蓝
        background: linear-gradient(0deg, #0C73D8 1%, #0C73D8);
      }
    }
  }
</style>
